module.exports = __webpack_public_path__ + "img/Flyer.461b85bb.svg";